import * as url from '../../helpers/url_helper';
import { get, post, postWithFile } from '../../helpers/api_helper';

export const getAllBookingDataBasedOnSelectedMonthAPI = filterdata => {
	return post(url.GET_ALL_BOOKINGS_DATA_BASED_ON_SELECTED_MONTH, filterdata);
};

export const getBookingDetailDataAPI = bookingId => {
	return get(url.GET_BOOKING_DETAIL_DATA + '/' + bookingId);
};

export const getBookingFilterDataValuesAPI = data => {
	return post(url.BOOKING_FILTER_DATA_VALUES, data);
};

export const getBookingContainersListAPI = data => {
	return post(url.GET_CONTAINERS_LIST, data);
};

export const getBookingDocumentDataAPI = bookingId => {
	return get(url.GET_BOOKING_DOCUMENT_DATA + '/' + bookingId);
};
